import { render, staticRenderFns } from "./edit_branch.vue?vue&type=template&id=3f1e59a5&scoped=true"
import script from "./edit_branch.vue?vue&type=script&lang=js"
export * from "./edit_branch.vue?vue&type=script&lang=js"
import style0 from "./edit_branch.vue?vue&type=style&index=0&id=3f1e59a5&prod&lang=css"
import style1 from "./edit_branch.vue?vue&type=style&index=1&id=3f1e59a5&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1e59a5",
  null
  
)

export default component.exports